import React from 'react';
import clsx from "clsx";
// import PrintIcon from '@material-ui/icons/Print';
// import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
// import ExcelIcon from '../../../assets/excelIcon.png'
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, /* FormHelperText, Input, */ FormControl, InputLabel, Select, MenuItem, Toolbar, Typography } from '@material-ui/core';
import { TIPO_AFILIACION } from '../../../utils/constants';
import { useForm } from '../../../hooks/useForm';
import { Buscador } from '../../afiliaciones/Buscador';

const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginTop: 10,
    },
    title: {
      flex: "1 1 100%",
    },
    formControl: {
      marginLeft: 20,
      marginRight: 40,
      minWidth: 250,
    },
    formControlPeriod: {
      marginLeft: 20,
      marginRight: 30,
      minWidth: 110,
    },
    button: {
      // width: 200,  
      minWidth: 100,
      marginTop: 10,
      marginRight: 20,
    },
}));

const initialState = {
  // periodoDesde: '',
  // periodoHasta: '',
  idCategoria: 0
}

export const TableToolbarGeneracion = (props) => {
    const classes = useToolbarStyles();
    const { handleSearch, handleAddPropuestaAfiliado } = props;

    const { consultaAfiliado } = useSelector((state) => state.afiliacion);

    const [ formValues, handleInputChange ] = useForm(initialState);
    const { /* periodoDesde, periodoHasta, */ idCategoria } = formValues;

    /* const validationPeriod = (value) => {
      const reg = new RegExp('^[0-9]+$');

      if(value!==''){
        if(value.length !== 6)
          return true;
        else if(!reg.test(value))
          return true;
        else if(value.substring(0,2) > 12)
          return true;
      }
      return false;
    } */

    // const errorPeriodoDesde = validationPeriod(periodoDesde);
    // const errorPeriodoHasta = validationPeriod(periodoHasta);

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Facturación
        </Typography>
        {/* <BuscadorFacturacion 
          items={rows} 
          setFilteredList={setFilteredList} 
          resetCategorySelect={() => handleInputChange({ target: {name: 'idCategoria', value: 0 }})}
        /> */}
        <div style={{marginRight: 150}}>
          <Buscador idConsulta={"idConsulta"} tipoBusqueda={'TITULARES'}/>
        </div>
        <Button 
            variant="contained"
            style={{minWidth: 100}} 
            disabled={Object.keys(consultaAfiliado).length === 0}
            onClick={() => handleAddPropuestaAfiliado(consultaAfiliado)}
        >
            Agregar
        </Button>
        {/* <FormControl error={errorPeriodoDesde} className={classes.formControlPeriod} >
          <InputLabel htmlFor="periodoDesde">Periodo Desde</InputLabel>
          <Input
            id="periodoDesde"
            name="periodoDesde"
            value={periodoDesde}
            onChange={handleInputChange}
            aria-describedby="periodoDesdeErrorText"
          />
          {errorPeriodoDesde&&
              <FormHelperText id="periodoDesdeErrorText" style={{textAlign: 'center'}}>(ej: 022021) </FormHelperText>
          }
        </FormControl>
        <FormControl error={errorPeriodoHasta} className={classes.formControlPeriod} >
          <InputLabel htmlFor="periodoHasta">Periodo Hasta</InputLabel>
          <Input
            id="periodoHasta"
            name="periodoHasta"
            value={periodoHasta}
            onChange={handleInputChange}
            aria-describedby="periodoHastaErrorText"
          />
          {errorPeriodoHasta&&
              <FormHelperText id="periodoHastaErrorText" style={{textAlign: 'center'}}>(ej: 022021) </FormHelperText>
          }
        </FormControl> */}
        <FormControl className={classes.formControl}>
            <InputLabel id="categoriaSelectLabel">Tipo de afiliado</InputLabel>
            <Select
                labelId="categoriaSelectLabel"
                id="categoriaSelect"
                name="idCategoria"
                value={idCategoria}
                onChange={handleInputChange}
            >
                <MenuItem value={0}>
                    <em>Todos</em>
                </MenuItem>
                <MenuItem key={TIPO_AFILIACION.DJ} value={TIPO_AFILIACION.DJ}>DJ</MenuItem>
                <MenuItem key={TIPO_AFILIACION.TEMPORARIO_CON_CUOTA} value={TIPO_AFILIACION.TEMPORARIO}>TEMPORARIO</MenuItem>
                <MenuItem key={TIPO_AFILIACION.TEMPORARIO_CON_CUOTA} value={TIPO_AFILIACION.TEMPORARIO_CON_CUOTA}>TEMPORARIO CON CUOTA</MenuItem>
                <MenuItem key={TIPO_AFILIACION.ADHERENTE} value={TIPO_AFILIACION.ADHERENTE}>ADHERENTE</MenuItem>
                <MenuItem key={TIPO_AFILIACION.FONDO_DESEMPLEO} value={TIPO_AFILIACION.FONDO_DESEMPLEO}>FDO DESEMPLEO</MenuItem>
                
            </Select>
        </FormControl>
        {/* <Tooltip title="Imprimir">
            <Button
                onClick={props.handlePrint}
            >
                <PrintIcon fontSize="large"/>
            </Button>
        </Tooltip>
        <Tooltip title="Exportar Pdf">
            <Button
                onClick={() => props.handleGeneratePdf(props.idTipo)}
            >
                <PictureAsPdfIcon fontSize="large"/>
            </Button>
        </Tooltip>
        <Tooltip title="Exportar Excel">
            <Button
                style={{marginRight: 15}}
                onClick={() => props.handleExportExcel(props.idTipo)}
            >
                <img src={ExcelIcon} alt='excelIcon' style={{height: 33}}></img>
            </Button>
        </Tooltip> */}
        <Button 
            variant="contained" 
            color="primary" 
            className={classes.button}
            onClick={() => handleSearch(idCategoria)}
        >
            Buscar
        </Button>
      </Toolbar>
    );
  };